"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
exports.emailValidator = {
    name: 'email',
    validation: function (value, element, config) {
        var maxLength = config.maxLength || 254;
        var EMAIL_REGEXP = new RegExp("^(?=.{1," + maxLength + "}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$");
        return utils_1.isEmpty(value) || EMAIL_REGEXP.test(value);
    },
};
//# sourceMappingURL=EmailValidator.js.map